import { render } from "./CommonItem.vue?vue&type=template&id=48f079a0&ts=true"
import script from "./CommonItem.vue?vue&type=script&lang=ts"
export * from "./CommonItem.vue?vue&type=script&lang=ts"

import "./CommonItem.vue?vue&type=style&index=0&id=48f079a0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__